// 注册插件  按需引入 减小包大小
//  @element-ui  地址  http://element-cn.eleme.io/#/zh-CN

import Vue from "vue";
import "@/style/theme/index.css";
import "@/assets/css/reset.scss";

import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Dialog,
    Button,
    Input,
    Form,
    FormItem,
    Row,
    Col,
    Tree,
    Table,
    TableColumn,
    Pagination,
    Select,
    Option,
    DatePicker,
    Message,
    MessageBox,
    Popover,
    Loading,
    Autocomplete,
    Tooltip,
    Tabs,
    TabPane,
    Menu,
    MenuItem,
    Submenu,
    InputNumber,
    InfiniteScroll,
    Slider,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    Upload,
    Descriptions,
    DescriptionsItem,
    Tag
} from "element-ui";
import API from "@/api/httpApi";

Vue.use(Loading);
Vue.use(InfiniteScroll);
Vue.component("el-dropdown", Dropdown);
Vue.component("el-dropdown-menu", DropdownMenu);
Vue.component("el-dropdown-item", DropdownItem);
Vue.component("el-dialog", Dialog);
Vue.component("el-button", Button);
Vue.component("el-input", Input);
Vue.component("el-form", Form);
Vue.component("el-form-item", FormItem);
Vue.component("el-row", Row);
Vue.component("el-col", Col);
Vue.component("el-tree", Tree);
Vue.component("el-table", Table);
Vue.component("el-table-column", TableColumn);
Vue.component("el-pagination", Pagination);
Vue.component("el-select", Select);
Vue.component("el-option", Option);
Vue.component("el-date-picker", DatePicker);
Vue.component("el-popover", Popover);
Vue.component("el-autocomplete", Autocomplete);
Vue.component("el-tooltip", Tooltip);
Vue.component("el-tabs", Tabs);
Vue.component("el-tab-pane", TabPane);
Vue.component("el-menu", Menu);
Vue.component("el-menu-item", MenuItem);
Vue.component("el-submenu", Submenu);
Vue.component("el-input-number", InputNumber);
Vue.component("el-slider", Slider);
Vue.component("el-radio", Radio);
Vue.component("el-radio-group", RadioGroup);
Vue.component("el-radio-button", RadioButton);
Vue.component("el-checkbox", Checkbox);
Vue.component("el-upload", Upload);
Vue.component("el-descriptions", Descriptions);
Vue.component("el-descriptions-item", DescriptionsItem);
Vue.component("el-tag", Tag);

Vue.prototype.$msg = Message;
Vue.prototype.$msgBox = MessageBox;
Vue.prototype.$API = API;
Vue.prototype.$sleep = async(ms = 100) => {
    return new Promise(resolve =>
        setTimeout(() => {
            resolve();
        }, ms)
    );
};

export default Vue;
